import baseAPI from '@/api/baseAPI'

class UserAPI extends baseAPI {
  get entity() {
    return {
      route: `/users`,
      name: 'المستخدم'
    }
  }

  resendEmail(id){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/resend-email/${id}`)
          .then(response => resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
    })
  }

  changeStatus(id, userType, status){
    return new Promise((resolve, reject) => {
      return this.request.put(`${this.entity.route}/${id}/change-status`, {user_type: userType, status: status})
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
}

export default new UserAPI()
